// retrieve list of notifications constants
export const FETCH_NOTIFICATIONS_LOADING = "FETCH_NOTIFICATIONS_LOADING";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const CATCH_ERROR_NOTIFICATIONS = "CATCH_ERROR_NOTIFICATIONS";
export const CLEAR_ERROR_NOTIFICATIONS = "CLEAR_ERROR_NOTIFICATIONS";
